import React from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import './styles.scss';

interface Props {
  isDisabled?: boolean;
  loading: boolean;
  onClick(): void;
}

const SaveButton: React.FC<Props> = ({ isDisabled, loading, onClick }) => {
  return (
    <Button className="save-button" disabled={isDisabled || loading} onClick={() => onClick()}>
      {loading && (
        <Spinner
          as="span"
          animation="border"
          className="spinner"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      )}
      SAVE
    </Button>
  );
};

export default SaveButton;
